/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_CompanyInputs */

const en_create_company = /** @type {(inputs: Create_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create company`)
};

const de_create_company = /** @type {(inputs: Create_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen erstellen`)
};

/**
* | output |
* | --- |
* | "Create company" |
*
* @param {Create_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_company = /** @type {((inputs?: Create_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_create_company(inputs)
	return en_create_company(inputs)
});